<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top">
</app-back-header>

<h3 class="ms-2 mt-2 mb-3">Importa Fattura Elettronica</h3>

<div class="upload-container col-md-6">

  <form [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="xmlFile" class="upload-field-label mb-2">File XML</label>

      <!-- Drag & Drop Area: superficie piatta bianca con contorno nero 2px
           tratteggiato (il tratteggio dice "qui si trascina") e angolo
           basso-sinistra vivo a 90°, come le altre superfici BEIZY. -->
      <div
        class="drop-zone izy-sharp-bl"
        [class.drop-zone--over]="isDragOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="fileInput.click()">

        <div class="drop-zone-content">
          <mat-icon class="drop-zone-icon">cloud_upload</mat-icon>

          <div *ngIf="!selectedFile" class="drop-zone-text">
            <p class="mb-1">Trascina qui il file XML</p>
            <!-- <small class="text-muted">oppure</small>
            <button
              mat-stroked-button
              type="button"
              class="mt-2"
              (click)="$event.stopPropagation()">
              <mat-icon>attach_file</mat-icon>
              Seleziona dal dispositivo
            </button> -->
          </div>

          <!-- File scelto: riga bianca bordata nera 2px dentro l'area, come le
               voci di lista delle card di nuova fattura (.izy-item-card). -->
          <div *ngIf="selectedFile" class="selected-file izy-sharp-bl">
            <mat-icon class="file-icon">description</mat-icon>
            <div class="file-info">
              <strong>{{ selectedFile.name }}</strong>
              <small class="file-size d-block">
                Dimensione: {{ (selectedFile.size / 1024).toFixed(2) }} KB
              </small>
            </div>
            <button
              mat-icon-button
              type="button"
              (click)="removeFile($event)"
              aria-label="Rimuovi il file scelto"
              class="remove-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- Hidden file input -->
      <input
        #fileInput
        type="file"
        id="xmlFile"
        (change)="onFileSelected($event)"
        accept=".xml"
        style="display: none"
        required>

      <div *ngIf="!selectedFile" class="mt-3">
        <small class="upload-hint">
          Seleziona una Fattura Elettronica XML, poi premi il pulsante "Importa" in basso.
        </small>
      </div>
      <div *ngIf="!selectedFile" class="mt-2">
        <small class="upload-hint">
          I dati della fattura verranno controllati in automatico e importati.
        </small>
      </div>
    </div>

    <!-- Riepilogo dei dati letti dall'XML: card bianca bordata nera 2px con la
         testata su fondo panna separata dal tratto nero, la stessa fascia dei
         footer delle card fattura/notifica. -->
    <div *ngIf="selectedFile" class="mt-3 data-preview-card izy-sharp-bl custom-card-border">
      <p class="data-preview-title">Dati della fattura da importare</p>
      <ul class="list-unstyled mb-0 data-preview-list">
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">calendar_today</mat-icon>
          <span class="data-preview-label">Data di emissione</span>
          <strong>{{ invoiceDate }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">tag</mat-icon>
          <span class="data-preview-label">Numero progressivo</span>
          <strong>{{ invoiceNumber }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">business</mat-icon>
          <span class="data-preview-label">Cliente / Beneficiario</span>
          <strong>{{ invoiceCompany }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">euro</mat-icon>
          <span class="data-preview-label">Importo totale</span>
          <strong>€ {{ formatToItalian(invoiceTotal) }}</strong>
        </li>
      </ul>
    </div>

    <!-- Azione primaria della schermata: pillola petrol con bordo nero 2px. -->
    <div class="mt-3 form-actions d-flex justify-content-end gap-2">
      <button
        matButton="filled"
        type="submit"
        [disabled]="!uploadForm.valid || isUploading || !selectedFile"
        class="izy-button-primary custom-button-border">
        <mat-icon *ngIf="!isUploading">upload</mat-icon>
        <mat-spinner *ngIf="isUploading" diameter="20" class="d-inline-block me-2 izy-button-spinner"></mat-spinner>
        {{ isUploading ? 'Importando...' : 'Importa XML' }}
      </button>
    </div>

    <div *ngIf="uploadProgress > 0" class="progress mt-3">
      <div
        class="progress-bar"
        [style.width]="uploadProgress + '%'">
        {{ uploadProgress }}%
      </div>
    </div>

    <!-- Esiti: stessa card bianca bordata nera 2px del resto della pagina, con
         una fascia di colore a sinistra come segnale (rosso per l'errore, lime
         per l'esito positivo, lo stesso segnale delle notifiche da leggere). -->
    <div *ngIf="uploadError" class="upload-alert upload-alert--error izy-sharp-bl custom-card-border mt-3">
      <mat-icon class="upload-alert-icon">error_outline</mat-icon>
      <span>{{ uploadError }}</span>
    </div>

    <div *ngIf="!uploadSuccess">
      </div>

    <div *ngIf="uploadSuccess" class="upload-alert upload-alert--success izy-sharp-bl custom-card-border mt-3">
      <div class="d-flex align-items-center mb-3">
        <mat-icon class="me-2 flex-shrink-0 upload-alert-icon">check_circle</mat-icon>
        <strong>Fattura N.{{invoiceNumber}} emessa a favore di {{invoiceCompany}} importata con successo!</strong>
      </div>

      <div class="d-flex flex-wrap gap-2">
        <button
          matButton="filled"
          (click)="navigateToInvoices()"
          class="izy-button-primary custom-button-border">
          <mat-icon>list</mat-icon> Vai alle fatture
        </button>

        <button
          mat-stroked-button
          (click)="prepareNewUpload()"
          class="izy-button-ghost custom-button-border">
          <mat-icon>refresh</mat-icon> Carica un'altra
        </button>
      </div>
    </div>

  </form>
</div>
